module.exports = __webpack_public_path__ + "media/images/ui__textArrowRight-36fb77e899554b6e8e1e16740ce22cd6.png";